let PERCENTAGE_DISCOUNT = 1;

const setMinimumDiscount = (discountPercentage) => PERCENTAGE_DISCOUNT = discountPercentage;
const checkMinimumDiscount = ({discountPercentage}) => {
    return discountPercentage >= PERCENTAGE_DISCOUNT;
};

const checkMinimumDiscountStrikethroughPrice = ({discountPercentage}) => {
    return discountPercentage && discountPercentage >= 1;
};

const calculatePercentageDiscounted = (sellPrice, originalPrice) => {
    return ((originalPrice - sellPrice) / ((originalPrice + sellPrice) / 2)) * 100;
};

module.exports = {
    checkMinimumDiscount,
    setMinimumDiscount,
    checkMinimumDiscountStrikethroughPrice,
    calculatePercentageDiscounted,
};
